import { render, staticRenderFns } from "./Involucrados.vue?vue&type=template&id=c5760304&scoped=true&"
import script from "./Involucrados.vue?vue&type=script&lang=js&"
export * from "./Involucrados.vue?vue&type=script&lang=js&"
import style0 from "./Involucrados.vue?vue&type=style&index=0&id=c5760304&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5760304",
  null
  
)

export default component.exports